import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { CloudSun, ExternalLink, RefreshCw, Loader2 } from "lucide-react";

export const WwxForecast = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = (refresh = false) => {
    setBusy(true);
    api.get(`/pest/wwx-forecast${refresh ? "?refresh=true" : ""}`, { timeout: 90000 })
      .then(({ data }) => setD(data)).catch(() => setD({ error: true })).finally(() => setBusy(false));
  };
  useEffect(() => { load(); }, []);

  if (!d) return <div className="bg-white border border-stone-200 p-4 text-xs font-bold uppercase text-stone-400" data-testid="wwx-loading">Loading Western Wx forecast…</div>;
  if (d.error) return null;

  return (
    <div className="bg-white border border-stone-200" data-testid="wwx-forecast">
      <div className="flex flex-wrap items-center gap-2 px-4 py-2 border-b border-stone-200">
        <CloudSun size={16} className="text-sky-600" />
        <div className="font-bold uppercase text-xs tracking-wide flex-1">Western Weather Daily Forecast — Napa {d.issued ? `· ${d.issued}` : ""}</div>
        <a href={d.source_pdf} target="_blank" rel="noreferrer" data-testid="wwx-pdf-link" className="text-[10px] font-bold underline text-[#1F3D34] flex items-center gap-1"><ExternalLink size={11} /> Daily PDF</a>
        <a href={d.dashboard} target="_blank" rel="noreferrer" data-testid="wwx-dash-link" className="text-[10px] font-bold underline text-[#1F3D34] flex items-center gap-1"><ExternalLink size={11} /> Station Dashboard</a>
        <button data-testid="wwx-refresh" onClick={() => load(true)} disabled={busy} className="h-8 w-8 border border-stone-300 flex items-center justify-center">
          {busy ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />}
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead><tr className="text-left text-[9px] font-bold uppercase text-stone-500">
            <th className="px-4 py-1">Day</th><th className="px-2 py-1">Sky</th><th className="px-2 py-1 text-right">Hi/Lo °F</th>
            <th className="px-2 py-1 text-right">Min RH%</th><th className="px-2 py-1 text-right">Dew Pt</th>
            <th className="px-2 py-1 text-right">POP%</th><th className="px-2 py-1">Wind</th><th className="px-2 py-1 text-right">Precip</th>
          </tr></thead>
          <tbody>
            {(d.days || []).slice(0, 7).map((x, i) => (
              <tr key={i} className="border-t border-stone-100" data-testid={`wwx-day-${i}`}>
                <td className="px-4 py-1 font-bold">{x.day}</td>
                <td className="px-2 py-1">{x.sky || "—"}</td>
                <td className="px-2 py-1 text-right font-semibold">{x.max_temp ?? "—"}/{x.min_temp ?? "—"}</td>
                <td className={`px-2 py-1 text-right ${x.min_rh_pct >= 60 ? "text-amber-700 font-bold" : ""}`}>{x.min_rh_pct ?? "—"}</td>
                <td className="px-2 py-1 text-right">{x.dew_point ?? "—"}</td>
                <td className={`px-2 py-1 text-right ${x.pop_pct >= 30 ? "text-sky-700 font-bold" : ""}`}>{x.pop_pct ?? "—"}</td>
                <td className="px-2 py-1">{x.wind || "—"}</td>
                <td className="px-2 py-1 text-right">{x.precip_in ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {d.disease_note && (
        <div className="px-4 py-2 border-t border-stone-200 bg-amber-50 text-xs font-semibold text-amber-900" data-testid="wwx-disease-note">
          Disease pressure read: {d.disease_note}
        </div>
      )}
    </div>
  );
};

export default WwxForecast;
